// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3WzOv","title":"card_title__1TjmB","inActive":"card_inActive__3oGvU"};